// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","orange":"#ef8d07","light-grey":"#d4d4d4","dark-purple":"#4a2e5e","notification":"_32NGk_ja0rqN-UYg7LkMXp","entered":"nvj3ozOiW-xcjE5DSpDqL","informativeSection":"YikMBi6PIMZb5Q1hX4olU","actionSection":"_3PIuO879PsI30pmq7V8DlD","informativeMessage":"_39FRxWQgRtMv-0taoAPgsh","details":"_1B0JXDVGaTXHXTRxS001Mp"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Notification/ActionNotification/ActionNotification.css
// module id = 1308
// module chunks = 0